import { CompilerContent } from '@ws/shared/components';
import { TFormatted } from '@ws/shared/types';
import { useContext } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';

import { BoardManagerCtx, EBoardType } from '../../../context/BoardManagerContext/context';
import { useNote } from '../../../hooks';
import { setSelectedSecondaryNode } from '../../../redux/editor';
import { InCompilerEditor } from '../../Editor';
import { useNoteContainer } from '../../TkPanel/noteContainers';

import { CompilerTemplate } from './CompilerTemplate';
import { CompleteButton } from './CompleteButton';
import { EditButton } from './EditButton';
import { NoteName } from './NoteName/NoteName';

export interface ICompiledContainerProps {
  entity: TFormatted;
  isSelected: boolean;

  onEntityClick(): void;

  isEditing: boolean;

  onEdit(): void;
}

export function CompilerContainer({
  entity,
  isSelected,
  onEntityClick,
  isEditing,
  onEdit,
}: ICompiledContainerProps) {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { board } = useContext(BoardManagerCtx);

  const { projectId } = useParams<{ projectId: string }>();
  const note = useNote(entity.id);
  const noteContainerRef = useNoteContainer(entity.id);

  function handleNoteHeaderClick() {
    if (board === EBoardType.MIAN) {
      navigate(`/project/${projectId}/node/${entity.id}`);
      return;
    }

    dispatch(setSelectedSecondaryNode({ secondarySelected: { id: entity.id, type: 'note' } }));
  }

  return (
    <>
      <CompilerTemplate
        containerRef={noteContainerRef}
        isEditing={isEditing}
        content={<CompilerContent entity={entity} onClick={onEntityClick} />}
        editor={
          note &&
          isEditing && (
            <CompilerContent type="in-compiler" entity={entity}>
              <InCompilerEditor note={note} />
            </CompilerContent>
          )
        }
        noteName={<NoteName onClick={handleNoteHeaderClick}>{entity.originalName}</NoteName>}
        editButton={isSelected && !isEditing && <EditButton onClick={onEdit} />}
        completeButton={note && isEditing && <CompleteButton isDesktopOnly onClick={onEdit} />}
      />
      {note && isEditing && <CompleteButton isNotDesktop onClick={onEdit} />}
    </>
  );
}
